module.exports = __webpack_public_path__ + "static/img/eicad_item7.39f67558.png";